import { parseIsoDateToMDYUS } from "./dateUtils";
/**
 * Standardizes signature data for application forms.
 * Handles applicant signature dates and conditionally includes admin signature fields based on role.
 * 
 * @param {Object} data The form data object containing signature fields
 * @param {boolean} isAdmin Whether the current user is an admin
 * @returns {Object} An object containing standardized signature fields
 */
export const getStandardizedSignatures = (data) => {
    return {
        applicantSignedAt: (data.applicantSignedAt || data.applicantSignatureDate || "").split('T')[0],
        reviewedBySignature: data.reviewedBySignature || data.adminSignature || "",
        reviewedBySignedAt: (data.reviewedBySignedAt || data.adminSignatureDate || data.reviewedBySignatureDate || "")?.split('T')[0] || "",
        reviewedBySignedBy: data.reviewedBySignedBy || ""
    };
};

export const getStandardizedSignaturesForGeneralForms = (data) => {
    return {
        applicantSignedAt: parseIsoDateToMDYUS(data.applicantSignedAt || data.applicantSignatureDate || ""),
        reviewedBySignature: data.reviewedBySignature || data.adminSignature || "",
        reviewedBySignedAt: parseIsoDateToMDYUS(data.reviewedBySignedAt || data.adminSignatureDate || data.reviewedBySignatureDate || ""),
        reviewedBySignedBy: data.reviewedBySignedBy || ""
    };
};
